import { Reveal } from './Reveal';
import { LANDING_ANCHORS, LANDING_CASES } from '../../domain/landingContent';

const TRANS = 'transition-all duration-500 ease-[cubic-bezier(0.32,0.72,0,1)]';

const caso = LANDING_CASES[0]!;

/** Case de sucesso da rede Espetos Grill. */
export function LandingCaseStudy() {
  return (
    <section id={LANDING_ANCHORS.cases} className="mx-auto max-w-6xl scroll-mt-24 px-4 py-24 sm:px-6 sm:py-32">
      <Reveal className="mx-auto max-w-2xl text-center">
        <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
          Já na rede Espetos Grill
        </h2>
      </Reveal>

      <Reveal delay={0.06} className="mx-auto mt-12 max-w-3xl">
        <article
          className={`${TRANS} flex h-full flex-col rounded-[2rem] border p-6 sm:p-7 ${
            caso.destaque
              ? 'border-orange-500/25 bg-gradient-to-br from-orange-500/10 to-transparent'
              : 'border-white/[0.06] bg-white/[0.03] hover:border-orange-500/20'
          }`}
        >
          <span className="text-xs font-medium uppercase tracking-wider text-orange-400/80">
            {caso.unidade}
          </span>
          <h3 className="mt-2 text-lg font-semibold text-white">{caso.titulo}</h3>
          <dl className="mt-4 flex flex-1 flex-col gap-3 text-sm">
            <div>
              <dt className="text-xs font-semibold uppercase tracking-wider text-slate-500">
                Problema
              </dt>
              <dd className="mt-1 leading-relaxed text-slate-400">{caso.problema}</dd>
            </div>
            <div>
              <dt className="text-xs font-semibold uppercase tracking-wider text-slate-500">
                Solução
              </dt>
              <dd className="mt-1 leading-relaxed text-slate-400">{caso.solucao}</dd>
            </div>
            <div className="mt-auto rounded-2xl border border-emerald-500/20 bg-emerald-500/5 px-4 py-3">
              <dt className="text-xs font-semibold uppercase tracking-wider text-emerald-400/80">
                Resultado
              </dt>
              <dd className="mt-1 text-sm font-medium leading-relaxed text-emerald-200/90">
                {caso.resultado}
              </dd>
            </div>
          </dl>
        </article>
      </Reveal>
    </section>
  );
}
